export const isStarterAccount = (): boolean => {
  // @ts-ignore
  const clonedFrom = global?.me?.clonedFrom;

  // @ts-ignore
  const orgID = global?.me?.orgID;

  // @ts-ignore
  const bootScreen = global?.appSettings?.bootScreen;

  return (
    clonedFrom === 'paivcam-seed' ||
    orgID === 'paivcam-seed' ||
    bootScreen === 'Routes'
  );
};
